import React, { useEffect, useState } from "react";
import PublicLayout from "@/components/layout/PublicLayout";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { Handshake, ExternalLink, ArrowRight } from "lucide-react";

export default function Sponsors() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/sponsors").then(({ data }) => setItems(data.items || [])).catch(() => setItems([])).finally(() => setLoading(false));
  }, []);

  const banners = items.filter((s) => s.banner_image_url);
  const logos = items;

  return (
    <PublicLayout>
      <section className="bg-[#0A192F] text-white border-b-4 border-[#E63946]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-14">
          <div className="flex items-center gap-2 label-overline text-[#E63946]"><Handshake className="w-4 h-4" /> Partners</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tighter mt-3">Our Sponsors</h1>
          <p className="mt-5 text-white/70 max-w-2xl leading-relaxed">The partners powering Canadian amateur baseball development, recruiting and recognition.</p>
          <Link to="/sponsorship" data-testid="become-sponsor-cta" className="inline-flex items-center gap-2 mt-7 bg-[#E63946] hover:bg-[#D90429] px-6 py-3 text-sm font-semibold uppercase tracking-wider rounded-sm transition-colors">Become a Sponsor <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </section>

      <section className="bg-white py-16 min-h-[40vh]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {loading ? (
            <div className="text-center py-20 text-slate-400 text-sm">Loading…</div>
          ) : items.length === 0 ? (
            <div className="bg-[#F8F9FA] border border-dashed border-slate-300 rounded-sm p-12 text-center text-sm text-slate-500">Be the first CBR sponsor. <Link to="/sponsorship" className="text-[#E63946] font-semibold underline">See packages</Link></div>
          ) : (
            <>
              {banners.length > 0 && (
                <div className="space-y-4 mb-14" data-testid="sponsor-banners">
                  {banners.map((s) => (
                    <a key={s.id} href={s.website || "#"} target="_blank" rel="noreferrer" data-testid={`sponsor-banner-${s.id}`} className="block rounded-sm overflow-hidden border border-slate-200 hover:border-[#0A192F] transition-colors">
                      <img src={s.banner_image_url} alt={s.name} className="w-full object-cover" />
                    </a>
                  ))}
                </div>
              )}
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="sponsor-logos">
                {logos.map((s) => (
                  <a key={s.id} href={s.website || "#"} target="_blank" rel="noreferrer" data-testid={`sponsor-logo-${s.id}`}
                    className="group bg-white border border-slate-200 rounded-sm p-6 flex flex-col items-center justify-center gap-3 hover:border-[#0A192F] transition-colors min-h-[140px]">
                    {s.logo_url
                      ? <img src={s.logo_url} alt={s.name} className="h-16 object-contain opacity-80 group-hover:opacity-100 transition-opacity" />
                      : <span className="font-display uppercase tracking-tight text-slate-500 text-center">{s.name}</span>}
                    <span className="text-[11px] uppercase tracking-wider text-slate-400 flex items-center gap-1 group-hover:text-[#E63946]">{s.name}{s.website && <ExternalLink className="w-3 h-3" />}</span>
                  </a>
                ))}
              </div>
            </>
          )}
        </div>
      </section>
    </PublicLayout>
  );
}
